// @ts-nocheck
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
import { useSession } from "@toolkit/Framework/Store/Context/ContextHooks";
import React, { FC } from "react";

const enum fields {
    customerSegmentId = "customerSegmentId",
}

export interface SegmentRestrictedContentProps extends WidgetProps {
    id: string;
    fields: {
        [fields.customerSegmentId]: string;
    };
}

const SegmentRestrictedContent: FC<SegmentRestrictedContentProps> = ({ id, fields }) => {
    const { isEditing } = useShellContext();
    const session = useSession();

    const { customerSegmentId } = fields;
    const userPersonaIds = session?.personas?.map(persona => persona.id) ?? [];
    const hasAccess = isEditing || (!!customerSegmentId && userPersonaIds.includes(customerSegmentId));

    if (!hasAccess) {
        return null;
    }

    return <Zone zoneName="SegmentRestrictedContent" contentId={id} />;
};

const widgetModule: WidgetModule<Toolkit.FieldDefinition> = {
    component: SegmentRestrictedContent,
    definition: {
        group: constants.widgetGroup.layout,
        displayName: "Segment Restricted Content",
        icon: "",
        fieldDefinitions: [
            {
                name: fields.customerSegmentId,
                displayName: "Customer Segment",
                editorTemplate: "PersonaDropDownField",
                defaultValue: "",
                fieldType: "General",
                tooltip:
                    "Content placed inside this wrapper is only shown to signed-in users who belong to the selected " +
                    "customer segment (persona). While editing in the CMS the content is always visible.",
            },
        ],
    },
};

export default widgetModule;
